import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite/no-important';
import { DOVE_GRAY, ALTO } from '../../styles';
import Label from './Label';
import Error from './Error';

export const checkboxStyles = StyleSheet.create({
  checkboxContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
  },
  checkboxInput: {
    marginBottom: 10,
    marginRight: 10,
    width: 'auto',
  },
});

const s = StyleSheet.create({
  root: {
    position: 'relative',
    display: 'block',
    width: '100%',
    marginBottom: 12,
  },
  input: {
    width: '100%',
    outline: 0,
    fontSize: 16,
    padding: '8px 11px',
    color: DOVE_GRAY,
    borderRadius: 2,
    borderColor: ALTO,
    borderWidth: 1,
    borderStyle: 'solid',
  },
});

const Input = ({
  label,
  error,
  __inputClass,
  indicator,
  required,
  value,
  __containerClass,
  ...props
}) => (
  <label className={css(s.root, __containerClass)}>
    {!!label && <Label messageId={label} />}
    <input
      {...props}
      value={value}
      required={required}
      className={css(s.input, __inputClass)}
    />
    {!!indicator && React.createElement(indicator, { value })}
    {(!!error || (!value && required)) && (
      <Error messageId={error || 'This field can not be empty!'} />
    )}
  </label>
);

Input.propTypes = {
  __inputClass: PropTypes.any,
  __containerClass: PropTypes.any,
  label: PropTypes.string,
  indicator: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  required: PropTypes.bool,
};

export default Input;
